/**
 * Collection Page Accordion Functionality
 * Handles FAQ accordion interactions for collection pages
 */

document.addEventListener('DOMContentLoaded', function() {
  initCollectionAccordion();
});

function initCollectionAccordion() {
  const accordionContainer = document.getElementById('collection-faq-accordion');
  
  if (accordionContainer) {
    initNewFormatAccordion(accordionContainer);
  } else {
    initOldFormatAccordion();
  }
}

/**
 * Initialize new JSON format accordion
 */
function initNewFormatAccordion(container) {
  const accordionHeaders = container.querySelectorAll('.accordion-header');
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      toggleAccordionItem(this.parentElement, container);
    });
  });
  
  // Toggle button click handler
  const toggleButtons = container.querySelectorAll('.accordion-toggle');
  toggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      this.closest('.accordion-header').click();
    });
  });
}

/**
 * Initialize old HTML format accordion (backward compatibility)
 */
function initOldFormatAccordion() {
  const oldAccordionContainer = document.querySelector('.collection-accordion');
  if (!oldAccordionContainer || oldAccordionContainer.id) return;
  
  const elements = Array.from(oldAccordionContainer.children);
  let currentAccordionItem = null;
  const accordionItems = [];
  
  elements.forEach(element => {
    if (element.tagName === 'H3') {
      currentAccordionItem = createAccordionItem(element);
      accordionItems.push(currentAccordionItem);
    } else if (element.tagName === 'P' && currentAccordionItem) {
      const content = currentAccordionItem.querySelector('.accordion-content');
      content.appendChild(element.cloneNode(true));
    }
  });
  
  // Replace original content
  oldAccordionContainer.innerHTML = '';
  accordionItems.forEach(item => oldAccordionContainer.appendChild(item));
  
  // Add event listeners
  attachAccordionListeners(oldAccordionContainer);
  
  // Open first item by default
  const firstItem = oldAccordionContainer.querySelector('.accordion-item');
  if (firstItem) firstItem.classList.add('active');
}

/**
 * Create accordion item from H3 element
 */
function createAccordionItem(headingElement) {
  const item = document.createElement('div');
  item.className = 'accordion-item';
  
  const header = document.createElement('div');
  header.className = 'accordion-header';
  
  const h3 = headingElement.cloneNode(true);
  const toggle = document.createElement('button');
  toggle.className = 'accordion-toggle';
  toggle.innerHTML = '+';
  toggle.setAttribute('aria-label', 'Toggle answer');
  toggle.setAttribute('type', 'button');
  
  header.appendChild(h3);
  header.appendChild(toggle);
  item.appendChild(header);
  
  const content = document.createElement('div');
  content.className = 'accordion-content';
  item.appendChild(content);
  
  return item;
}

/**
 * Attach click listeners to accordion
 */
function attachAccordionListeners(container) {
  const headers = container.querySelectorAll('.accordion-header');
  
  headers.forEach(header => {
    header.addEventListener('click', function() {
      toggleAccordionItem(this.parentElement, container);
    });
  });
  
  const toggleButtons = container.querySelectorAll('.accordion-toggle');
  toggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      const item = this.closest('.accordion-item');
      toggleAccordionItem(item, container);
    });
  });
}

/**
 * Toggle accordion item open/closed state
 */
function toggleAccordionItem(item, container) {
  const isActive = item.classList.contains('active');
  
  // Close all items
  container.querySelectorAll('.accordion-item').forEach(otherItem => {
    otherItem.classList.remove('active');
  });
  
  // Open current item if it wasn't active
  if (!isActive) {
    item.classList.add('active');
  }
}